import { createGlobalStyle } from 'styled-components';
import fontSize from './settings/fontSize';

export default createGlobalStyle`
  .btn-text span {
    font-size: ${fontSize.actionsButtonHeader}
  }

  .btn-text[disabled] {
    cursor: not-allowed;
    opacity: 0.85;
  }

  .btn-smaller-text span {
    font-size: ${fontSize.actionsButtonSmallerHeader}
  }

  .btn-text[disabled] {
    cursor: not-allowed;
    opacity: 0.85;
  }

  .pointer {
    cursor: pointer;
  }

  .w-100 {
    width: 100%;
  }

  .w-35 {
    width: 35%;
  }

  .ml-3 {
    margin-left: 24px;
  }
  .ml-4 {
    margin-left: 32px;
  }

  .text-center {
    text-align: center;
  }
  
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .text-left-block {
    display: block;
    text-align: left;
  }
  .text-right-block {
    display: block;
    text-align: right;
  }
  .text-center-block {
    display: block;
    text-align: center;
  }
  .d-block {
    display: block;
  }

  .real-formatted {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 100%;
  }

  .toUppercase{
    text-transform: uppercase;
    input {
      text-transform: uppercase;
    }
  }

  .react-datepicker__tab-loop {
    z-index: 9;
  }

  .MuiTableBody-root {
    .MuiTableRow-root:nth-child(even){
      background-color: rgb(238, 238, 238);;
    }
            
    .MuiTableRow-root:nth-child(odd){
      background-color: #fff;
    }
  }
`;
